<mat-form-field>
  <!-- <mat-label>Consumption Mode</mat-label> -->
  @if (selectedConsumptionModeModel) {
    <mat-icon
      matPrefix
      class="consumption-icon"
      [svgIcon]="selectedConsumptionModeModel?.icon"
      color="primary"
    [ngClass]="selectedConsumptionModeModel?.iconColor"></mat-icon>
  }
  <mat-select [value]="selectedConsumptionModeModel"
    (selectionChange)="consumptionModeChange.emit($event.value.type)"
    [disabled]="readonly"
    [panelWidth]="null">
    @for (mode of consumptionModeModels; track mode) {
      <mat-option
        [value]="mode">
        <mat-icon class="consumption-icon"
          [svgIcon]="mode.icon"
          color="primary"
        [ngClass]="mode.iconColor"></mat-icon>{{ mode.transKey | transloco}}
      </mat-option>
    }
  </mat-select>
  <mat-icon matSuffix
  class="select-arrow-icon">keyboard_arrow_down</mat-icon>
</mat-form-field>
